import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './Intl/i18n';
import * as serviceWorker from './utils/serviceWorker';
import { initializeMixpanel } from './utils/mixpanel';

initializeMixpanel();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
